import { Divider, List, ListItem, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import {
  spacing,
  typography,
  colors,
} from "../../../../../../../../../assets/styles/tokens";

interface NegativeBalanceMoreMetricsProps {
  cpaIncome: string;
  rsIncome: string;
  clickOut: string;
  regs: string;
  ftd: string;
  qftd: string;
  brandPolicyPlan: string;
}

const rowStyles = {
  fontSize: typography.Size.Text.xs.$value,
  lineHeight: typography.Line_height.text.xs.$value,
  display: "flex",
  justifyContent: "space-between",
} as const;

const valueStyles = {
  fontWeight: typography.Font_weight.Semibold.$value,
  fontSize: typography.Size.Text.sm.$value,
} as const;

const NegativeBalanceMoreMetrics = ({
  cpaIncome,
  rsIncome,
  clickOut,
  regs,
  ftd,
  qftd,
  brandPolicyPlan,
}: NegativeBalanceMoreMetricsProps) => {
  const metrics: { label: string; value: string }[] = [
    { label: "CPA INCOME $", value: cpaIncome },
    { label: "RS INCOME $", value: rsIncome },
    { label: "CLICK OUT", value: clickOut },
    { label: "REGS", value: regs },
    { label: "FTD", value: ftd },
    { label: "QFTD", value: qftd },
    { label: "BRAND POLICY PLAN", value: brandPolicyPlan },
  ];

  return (
    <>
      <Stack>
        <List sx={{ pb: 0, color: colors.GrayLightMode[900].$value }}>
          {metrics.map((metric, index) => (
            <Box key={metric.label}>
              <ListItem
                sx={{
                  width: "100%",
                  display: "block",
                  p: spacing.Spacing.sm.$value,
                }}
              >
                <Typography sx={rowStyles}>
                  <Box>{metric.label}</Box>
                  <Box sx={valueStyles}>{metric.value}</Box>
                </Typography>
              </ListItem>
              {index < metrics.length - 1 && <Divider />}
            </Box>
          ))}
        </List>
      </Stack>
    </>
  );
};

export default NegativeBalanceMoreMetrics;
